import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-des-checkout-page',
  templateUrl: './des-checkout-page.component.html',
  styleUrl: './des-checkout-page.component.scss',
})
export class DesCheckoutPageComponent implements OnInit {
  purchaseId?: string;
  tenantId?: string;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.purchaseId = this.route.snapshot.params['id'];
    this.tenantId =
      this.route.snapshot.queryParamMap.get('tenant_id') ||
      this.authService.currentUser?.tenant_id;
  }
}
